import {faBuilding} from "@fortawesome/free-solid-svg-icons";
import {CompanyModel, CompanyReportModel} from '../../redux/companyMonitorTypes';
import CompanyReportInfoCard from './CompanyReportInfoCard';
import CountryFlag from '../CountryFlag';

interface Props {
  report: CompanyReportModel
  company?: CompanyModel
}

const CompanyReportGeneralInfoCard = ({report, company}: Props) => {
  return (
    <CompanyReportInfoCard title='General company info' icon={faBuilding} sources={['CreditSafe']}>
      <p>Name: <span>{company?.name ?? '-'}</span></p>
      <p>Registration number: <span>{company?.companyRegistrationNumber ?? '-'}</span></p>
      {/* The country is read off the report, not the company, so that it reflects
          the report at the time it was created rather than the current company record. */}
      <p>Country: <span style={{textTransform: 'uppercase'}}>
        {report.country ? <><CountryFlag country={report.country}/>{' '}{report.country}</> : '-'}
      </span></p>
      <p>County: <span>{report.county ?? '-'}</span></p>
      <p>Municipality: <span>{report.municipality ?? '-'}</span></p>
    </CompanyReportInfoCard>
  )
}
export default CompanyReportGeneralInfoCard
